// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"91079463","342":"a38e0c7a"}[chunkId] + ".chunk.js";
};